<template>
  <div id="crm-detail-image" class="crm-detail-theme-half">
    <div
      v-if="showBack"
      @click="handleBack"
      class="crm-detail-theme-bg-icon-back"
    >
      <i class="el-icon-back" />
    </div>
    <slot />
  </div>
</template>

<script>
import { mapGetters ,mapMutations } from "vuex";
export default {
  props: {
    showBack: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      crm_public_path: process.env.VUE_APP_S3_PUBLIC_PATH,
    };
  },
  async mounted() {
    document.getElementById(
      "crm-detail-image"
    ).style.backgroundImage = `url('${process.env.VUE_APP_S3_PUBLIC_PATH}${this.promotionDetail.imageKey}')`;
  },
  methods: {
    handleBack() {
      if(this.promotionDetail){
        this.clearRedeemProAddFriend()
        this.clearLineFriendToken()
      }
      this.$router.push({
        name: "Home",
        params: {
          restaurant_aliase: this.restaurantUUID,
          branch_aliase: this.branchUUID,
        },
      });
    },
    ...mapMutations({
      clearRedeemProAddFriend: "promotion/CLEAR_REDEEM_ADD_FRIEND",
      setRedeeming : "promotion/SET_REDEEMING_ADD_FRIEND",
      clearLineFriendToken: "user/CLEAR_LINE_FRIEND_TOKEN"
    }),
  },
  computed: {
    ...mapGetters({
      promotionDetail: "promotion/promotionDetail",
      restaurantUUID: "restaurant/restaurantUUID",
      branchUUID: "branch/branchUUID",
    }),
  },
};
</script>

<style scoped>
.crm-detail-theme-half {
  position: relative;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  min-height: calc(50vh);
}

.crm-detail-theme-bg-icon-back {
  position: absolute;
  left: 16px;
  top: 40px;
  font-size: 22px;
  color: #000000;
  background-color: #ffffff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 12px rgba(157, 164, 179, 0.35);
}

.title-text {
  font-weight: 500;
  font-size: 24px;
  line-height: 16px;
  color: #ffffff;
  position: absolute;
  top: 55px;
  text-align: center;
  width: 100%;
}
</style>